import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { DownloadsComponent } from './components/downloads.component';

@NgModule({
  declarations: [DownloadsComponent],
  imports: [
      CommonModule,
      SharedModule
  ]
})
export class DownloadsModule { }
